export default __webpack_public_path__ + "static/media/iphoneDetail.367b62b7.png";